import axios from 'axios'
import config from '../aws-config'

export const axiosInstance = axios.create({
    baseURL: config.solve.endpoint,
})